import { PAGOS_POR_VENTA_MAXIMO } from '@tanteo/compartido';
import type { PagoDeVenta } from './api';

/**
 * El reparto de una venta entre varias cuentas mientras el cajero lo escribe: lo asignado tiene que
 * ser exactamente el total. Quien decide es el servidor; esto solo le muestra cuánto falta.
 */

/** Lo que el cajero lleva escrito, por cuenta. `null` es una casilla vacía. */
export type Reparto = Record<string, number | null>;

export function asignado(reparto: Reparto): number {
  return Object.values(reparto).reduce<number>((suma, monto) => suma + (monto ?? 0), 0);
}

/** Positivo: falta por asignar. Negativo: se pasó. Cero: cuadra. */
export function faltaPorAsignar(total: number, reparto: Reparto): number {
  return total - asignado(reparto);
}

/** Los pagos que se enviarían: solo las cuentas con monto, en el orden en que se escribieron. */
export function pagosDeReparto(reparto: Reparto): PagoDeVenta[] {
  return Object.entries(reparto)
    .filter(([, monto]) => (monto ?? 0) > 0)
    .map(([cuentaId, monto]) => ({ cuentaId, monto: monto as number }));
}

/** Más cuentas con monto de las que la base admite en una venta. */
export function excedePagos(reparto: Reparto): boolean {
  return pagosDeReparto(reparto).length > PAGOS_POR_VENTA_MAXIMO;
}

/** Cierra solo si cuadra al peso y cabe en el tope de pagos. Con una sola cuenta también vale. */
export function repartoValido(total: number, reparto: Reparto): boolean {
  return total > 0 && faltaPorAsignar(total, reparto) === 0 && pagosDeReparto(reparto).length >= 1 && !excedePagos(reparto);
}
